import React, { FC, ReactElement } from 'react';
import _ from 'lodash';
import { PageSectionCont, SectionTitle } from './PageSection.styles';

interface IPageSection {
  children: ReactElement;
  title?: string;
  isUnstyled?: boolean;
  width?: 'full' | 'half';
}

const PageSection: FC<IPageSection> = ({ children, title, isUnstyled = false, width = 'full' }) => (
  <>
    {title && <SectionTitle id="SectionTitle">{title}</SectionTitle>}
    <PageSectionCont
      id="PageSectionCont"
      isTitle={!_.isUndefined(title)}
      {...{ isUnstyled, width }}
    >
      {children}
    </PageSectionCont>
  </>
);

export default PageSection;
